import React, { useState } from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import { MerchantNavItem } from './MerchantNavItem'
import { useCurrentUserMerchantRoles } from '../../hooks'
import { MerchantSelectorPopup } from './MerchantSelectorPopup'
import { getValidAccessToken } from '../../features/auth'

const Wrapper = styled.div``

export const MerchantSelector = ({ className }) => {
	const [showMerchantSelector, setShowMerchantSelector] = useState(false)
	const { connectedToMultipleMerchants } = useCurrentUserMerchantRoles()

	const handleNavItemClick = async () => {
		if (!connectedToMultipleMerchants) return
		const token = await getValidAccessToken()
		if (!token) {
			const { location } = window
			location.href = `${location.origin}/login?${new URLSearchParams({
				redirectUrl: location.pathname + location.search,
			}).toString()}`
			return
		}
		setShowMerchantSelector(true)
	}

	return (
		<Wrapper className={className}>
			<MerchantSelectorPopup onClose={() => setShowMerchantSelector(false)} open={showMerchantSelector} />
			<MerchantNavItem onClick={handleNavItemClick} />
		</Wrapper>
	)
}

MerchantSelector.propTypes = {
	className: PropTypes.string,
}
